import type { HeaderProps } from 'components/Header';
import Header from 'components/Header';
import LoadingIndicator from 'components/LoadingIndicator';
import MenuTabBar from 'components/MenuTabBar';
import { createContext, Suspense, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

type LayoutContextType = {
  setLayoutProps?: (value: LayoutProps) => void;
};

interface LayoutProps extends HeaderProps {
  hideHeader?: boolean;
  hideMenu?: boolean;
}

const LayoutContext = createContext<LayoutContextType>({ setLayoutProps: undefined });
export function useLayout() {
  return useContext<LayoutContextType>(LayoutContext);
}

const Layout = ({ pre }: { pre?: boolean }) => {
  const [layoutProps, setLayoutProps] = useState<LayoutProps>({
    title: '',
    headerBorder: false,
    leftButtons: [],
    rightButtons: [],
    hideHeader: false,
    hideMenu: false,
  });

  return (
    <LayoutContext.Provider value={{ setLayoutProps }}>
      {!layoutProps.hideHeader && (
        <Header
          title={layoutProps.title}
          headerBorder={layoutProps.headerBorder}
          leftButtons={layoutProps.leftButtons}
          rightButtons={layoutProps.rightButtons}
        />
      )}
      <Suspense fallback={LoadingIndicator}>
        <Outlet />
      </Suspense>
      {!layoutProps.hideMenu && <MenuTabBar />}
    </LayoutContext.Provider>
  );
};
export default Layout;
